import { isMl3App, isiOS } from './DeviceOptions';
import { sleep, versionCompare } from './Utils';
import { haflCallAPI, haflCallAPIAppleLogin } from '../maplifeCommon/login';
// import { checkCurrentLocationIsOkinawa } from '../modules/Helpers';

/**
 * getMl3AppVersion
 * Get the app version for iOS
 *   (todo: android getMl3AppVersion)
 */
let ml3AppVersion;
let gettingMl3AppVersion = false;
export const getMl3AppVersion = () =>
  new Promise(async resolve => {
    if (isMl3App && isiOS) {
      if (ml3AppVersion) {
        return resolve(ml3AppVersion);
      }

      let i = 0;
      const cacheML3AV = gettingMl3AppVersion;

      while (!ml3AppVersion) {
        i++;
        if (!cacheML3AV) {
          gettingMl3AppVersion = true;
          setTimeout(() => {
            window.webkit.messageHandlers.func.postMessage('getAppVersion');
          }, 100);
        }
        await sleep();

        if (i > 3) {
          break;
        }
      }
    }

    resolve(ml3AppVersion);
  });
window.resultAppVersion = bundleNumber => {
  bundleNumber = bundleNumber.replace('MapLife/', '');
  ml3AppVersion = bundleNumber;
};
setTimeout(async () => {
  getMl3AppVersion();
}, 1000);

/**
 * NativeHideSplash
 * Hide iOS Splash screen
 */
export const NativeHideSplash = async () => {
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.0.5') >= 0) {
      window.webkit.messageHandlers.func.postMessage('hideSplash');
      setTimeout(() => {
        window.webkit.messageHandlers.func.postMessage('hideSplash');
      }, 300);
    }
  }
};
window.NativeHideSplash = NativeHideSplash;

/**
 * NativeGetDeviceToken
 * Get native device token. Currently only works in iOS
 */
let nativeDeviceToken;
export const NativeGetDeviceToken = () =>
  new Promise(async (resolve, reject) => {
    if (nativeDeviceToken) {
      return resolve(nativeDeviceToken);
    }

    if (!isMl3App) {
      return reject();
    }

    let i = 0;

    while (!nativeDeviceToken) {
      if (isiOS) {
        window.webkit.messageHandlers.func.postMessage('getDeviceToken');
      } else if (window.maplife && window.maplife.getDeviceToken) {
        window.maplife.getDeviceToken();
      }
      i++;

      await sleep();

      if (i > 3) {
        return reject();
      }
    }

    resolve(nativeDeviceToken);
  });
window.resultDeviceToken = deviceToken => {
  nativeDeviceToken = deviceToken;
};

/**
 * FBNativeLoginStart
 */
export const FacebookMl3AppLogin = async () => {
  if (!isMl3App) {
    return;
  }

  if (isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.0') >= 0) {
      window.webkit.messageHandlers.func.postMessage('FBNativeLoginStart');
      return;
    }
  } else {
    //android login with fbsdk
    maplife.FBAndroidNativeLoginStart();
  }

};

window.FBNativeLoginSuccess = data => {
  data = JSON.parse(data);
  haflCallAPI(
    {
      ...data,
      id: data.account
    },
    true
  );
};
window.FBNativeLoginFailure = () => {
  console.log('Facebook Login Failure');
};

// NativeInitGeoFence
export const NativeInitGeoFence = async () => {
  const version = await getMl3AppVersion();
  if (isMl3App && versionCompare(version, '3.1.1') >= 0) {
    // ! ==============================
    // ! to uncomment
    // const isInOkinawa = await checkCurrentLocationIsOkinawa();
    // if (isInOkinawa) {
    window.webkit.messageHandlers.func.postMessage('initGeoFence');
    // }
    // ! ==============================
  }
};

let nativeGFList;
export const NativeGetGFList = async () => {
  if (isMl3App && isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.1') >= 0) {
      // get data here
      let i = 0;
      while (!nativeGFList) {
        i++;
        window.webkit.messageHandlers.func.postMessage('getGFlist');
        await sleep();
        if (i > 3) {
          break;
        }
      }
    }
  }

  if (!nativeGFList) {
    throw new Error();
  }

  // list = [
  //   { ads_area_id: 1, title: '1111', enabled: 1 },
  //   { ads_area_id: 2, title: '2222', enabled: 0 }
  // ];

  return nativeGFList;
};
window.resultGFlist = list => {
  try {
    if (list === '(null)') {
      list = '[]';
    }
    list = JSON.parse(list);
    if (list) {
      nativeGFList = list;
    }
  } catch (error) {
    console.log(error);
  }
};

export const NativeSetGF = (ads_area_id = '', enable = false) => {
  if (isMl3App && isiOS) {
    const setFunc = enable ? `setGFenable(${ads_area_id}` : `setGFdisable(${ads_area_id})`;
    window.webkit.messageHandlers.func.postMessage(setFunc);
  }
};

// NativeClearNotificationsBadge
export const NativeClearNotificationsBadge = () => {
  if (isMl3App && isiOS) {
    window.webkit.messageHandlers.func.postMessage('clearNotificationsBadge');
  }
};

// android login with fbsdk
window.FBAndroidNativeLoginSuccess = (data) => {
  console.log("FBSDK - FBAndroidNativeLoginSuccess");
  haflCallAPI(
    {
      ...data,
      id: data.account
    },
    true
  );
}

window.FBAndroidNativeLoginFailure = () => {
  console.log("FBSDK - FBAndroidNativeLoginFailure");
};

/**
 * FBNativeShareLink
 */
 export const FacebookMl3AppShareLink = (link = "") => {
  if (!isMl3App) {
    return;
  }

  if (isiOS) {
    window.webkit.messageHandlers.func.postMessage('FBNativeShareLink('+encodeURIComponent(link)+')');
  } else {
    maplife.FBAndroidNativeShareLink(link);
  }
};

/**
 * Apple native login
 */
export const AppleMl3AppLogin = async () => {
  if (!isMl3App) {
    return;
  }

  if (isiOS) {
    const version = await getMl3AppVersion();
    if (versionCompare(version, '3.1.0') >= 0) {
      window.webkit.messageHandlers.func.postMessage('SsoAppleNativeLoginStart');
      return;
    }
  }
};

window.SsoAppleNativeLoginSuccess = data => {
  data = JSON.parse(data);
  haflCallAPIAppleLogin(
    {
      ...data,
      id: data.account
    },
    true
  );
};

window.SsoAppleNativeLoginFailure = () => {
  console.log('Apple Login Failure');
};